import React from "react";
import { photoIdCanvasDimensions } from "config/constant";
import { detectMob } from "helpers/browser-helper";
type Props = {
  height: number;
  width: number;
  videoRef: React.RefObject<HTMLVideoElement>;
  canvasRef: React.RefObject<HTMLCanvasElement>;
  captured?: boolean;
};
const Canvas: React.FC<Props> = (props) => {
  const photoCaptureRef = React.useRef<HTMLCanvasElement>(null);
  const { canvasWidth, canvasHeight } = photoIdCanvasDimensions;
  React.useEffect(() => {
    const videoEl = props.videoRef.current;
    const hiddenCanvas = props.canvasRef.current;
    if (!videoEl || !hiddenCanvas) return;

    const drawHiddenCanvas = () => {
      const context = hiddenCanvas.getContext("2d");
      if (!context) return;

      const isMobile = detectMob();
      const videoWidth = videoEl.videoWidth;
      const videoHeight = videoEl.videoHeight;

      if (isMobile && videoWidth > 0 && videoHeight > 0) {
        // Exact resolution capture for mobile devices.
        hiddenCanvas.width = videoWidth;
        hiddenCanvas.height = videoHeight;
        context.drawImage(videoEl, 0, 0, videoWidth, videoHeight);
      } else {
        context.drawImage(videoEl, 0, 0, canvasWidth, canvasHeight);
      }
    };

    // Ensure we have video metadata before drawing on mobile.
    if (videoEl.readyState >= 1) {
      drawHiddenCanvas();
    } else {
      videoEl.addEventListener("loadedmetadata", drawHiddenCanvas, { once: true });
    }

    const photoContext = photoCaptureRef.current?.getContext("2d");
    if (photoContext) {
      photoContext.drawImage(videoEl, 0, 0, props.width, props.height);
    }

    return () => {
      videoEl.removeEventListener("loadedmetadata", drawHiddenCanvas);
    };
  }, [canvasWidth, canvasHeight, props.videoRef, props.canvasRef, props.width, props.height]);

  return (
    <>
      <canvas
        role="img"
        style={{ display: "none" }}
        className="tvp-photoIdCanvas"
        ref={props.canvasRef}
        height={canvasHeight}
        width={canvasWidth}
      />
      <canvas
        role="img"
        className="tvp-photoIdCanvas"
        ref={photoCaptureRef}
        height={props.height}
        width={props.width}
      />
    </>
  );
};

export default Canvas;
